'use client'

import { Toaster as ChakraToaster, Portal, Spinner, Stack, Toast } from '@chakra-ui/react'
import { toaster } from './toasterInstance'

export const Toaster = () => {
  return (
    <Portal>
      <ChakraToaster toaster={toaster} insetInline={{ mdDown: '4' }}>
        {toast => (
          // The action trigger has a fixed height, so squeezing it beside the text wrapped its
          // label out of the button. With an action the row may wrap instead: the button keeps
          // its natural width and moves below the text when there is no room beside it.
          <Toast.Root width={{ md: 'sm' }} flexWrap={toast.action ? 'wrap' : undefined}>
            {toast.type === 'loading' ? (
              <Spinner size="sm" color="blue.solid" />
            ) : (
              <Toast.Indicator />
            )}
            <Stack gap="1" flex="1" maxWidth="100%">
              {toast.title && <Toast.Title>{toast.title}</Toast.Title>}
              {toast.description && <Toast.Description>{toast.description}</Toast.Description>}
            </Stack>
            {toast.action && (
              <Toast.ActionTrigger flexShrink={0}>{toast.action.label}</Toast.ActionTrigger>
            )}
            {toast.closable && <Toast.CloseTrigger />}
          </Toast.Root>
        )}
      </ChakraToaster>
    </Portal>
  )
}
